function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 8.6147L0 13.948C0 14.6814 0.6 15.2814 1.33333 15.2814L5.33333 15.2814L9.72 19.668C10.56 20.508 12 19.908 12 18.7214L12 3.82803C12 2.64136 10.56 2.04136 9.72 2.88136L5.33333 7.28136L1.33333 7.28136C0.6 7.28136 0 7.88136 0 8.6147ZM18 11.2814C18 8.92136 16.64 6.8947 14.6667 5.90803L14.6667 16.6414C16.64 15.668 18 13.6414 18 11.2814ZM14.6667 1.2147L14.6667 1.48136C14.6667 1.98803 15 2.42803 15.4667 2.6147C18.9067 3.98803 21.3333 7.36136 21.3333 11.2814C21.3333 15.2014 18.9067 18.5747 15.4667 19.948C14.9867 20.1347 14.6667 20.5747 14.6667 21.0814L14.6667 21.348C14.6667 22.188 15.5067 22.7747 16.28 22.4814C20.8 20.7614 24 16.4014 24 11.2814C24 6.16136 20.8 1.80136 16.28 0.0813633C15.5067 -0.225303 14.6667 0.374697 14.6667 1.2147Z",
  stroke: "none"
});

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.7a0d0262.svg";
export { ForwardRef as ReactComponent };